import React from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';

class ChangeReceiptDate extends React.Component {

    state = {
      fullWidth: true,
      maxWidth: 'xs',
      date: this.props.item.date
    }

    changeDate = (date) => {
        let context = this;
        let { item } = this.props;
        let data = { date, 'id': item.id };
        $.ajax({
            type: 'POST', data,
            url: Server() + 'receipt/changedate.php',
            success: function(data) {
              if (data == 1) {
                context.setState({ ChangeReceiptDateDialog: false, load: false });
                context.props.updateData();
              }
              else {
                context.setState({ load: false, });
              }
            },
            error: function(e) {
              alert('Try again!!')
              context.setState({ load: false });
            }
          });
    }

    render() {
        let { item } = this.props;
        return (
            <div>
                <b style={{cursor: 'pointer', color: '#415F9D'}} 
                    onClick={ () => { this.setState({ ChangeReceiptDateDialog: true }) }}>
                        {item.date}
                </b>
                
                <Dialog fullWidth={this.state.fullWidth}
                maxWidth={this.state.maxWidth}  open={this.state.ChangeReceiptDateDialog}
                onClose={ () => { this.setState({ ChangeReceiptDateDialog: false }) }} aria-labelledby="max-width-dialog-title">
                <DialogTitle id="max-width-dialog-title">Change Date</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <TextField label="From" type="date"
                            onChange={ (e) => this.changeDate(e.target.value) }
                            defaultValue={this.state.date} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => { this.setState({ ChangeReceiptDateDialog: false }) } }>Close</Button>
                </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default ChangeReceiptDate;